import { NotificationsApiResponse } from '../types/notifications';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://bagr.iprosystems.com/api';
const API_KEY = import.meta.env.VITE_API_KEY;
const SITE_ID = import.meta.env.VITE_SITE_ID || 'marketplacedev';

/**
 * Fetches notifications from the API
 */
export async function fetchNotifications(): Promise<NotificationsApiResponse> {
  const url = new URL(`${API_BASE_URL}/notifications`);
  url.searchParams.append('populate[site]', '*');
  url.searchParams.append('populate[locations]', '*');
  url.searchParams.append('filters[site][SiteID][$eq]', SITE_ID);

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  // Add API key to headers if provided
  if (API_KEY) {
    headers['Authorization'] = `Bearer ${API_KEY}`;
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch notifications: ${response.status} ${response.statusText}`);
  }

  return response.json();
}





